import axios from "axios";

const API_URL_Local = process.env.REACT_APP_API_URL;
//const API_URL_Local = "http://172.27.181.225:8100/api/v2/";
// const API_URL_Local = "https://amethyst.gistda.or.th/api/v2/"
const handleError = (error) => {
  if (error.response) {
    // Error จากการตอบกลับของเซิร์ฟเวอร์
    if(error.response.data.error_description){
      throw error.response.data.error_description
    }else{
      throw "respone error"
    }
    
  } else if (error.request) {
    // Error เกิดขึ้นในระหว่าง request ถูกส่งแต่ไม่ได้รับการตอบกลับ
    console.error("Network Error:", error.request);
    //alert("Network error. Please check your internet connection.");
    throw "Request Error"
  } else {
    // Error จากการตั้งค่าหรืออื่น ๆ
    console.error("Error:", error.message);
    
    //alert(error.message);
    throw "Error Message"
  }
};



const GetCorporationApproval = () =>{
    const access_token = sessionStorage.getItem("access_token");
    const checktoken = localStorage.getItem("access_token");
  if(checktoken != null){
    return axios
    .get(API_URL_Local +"admin/corporation-approve-request", {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      })
      .then((response) => {
        return response;
      })
      .catch((error)=>{
        handleError(error);
        throw error
      })}
}
const ApproveCorporation = (corporation_id) =>{
    console.log(corporation_id)
    const access_token = sessionStorage.getItem("access_token");
    const checktoken = localStorage.getItem("access_token");
  if(checktoken != null){
    return axios
    .post(API_URL_Local +`admin/approve-corporation?corporation_id=${corporation_id}`,{}, {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      })
      .then((response) => {
        return response;
      })
      .catch((error) => {
        handleError(error);
        throw error
      });}
}
const Adminservice = {
    GetCorporationApproval,
    ApproveCorporation
}
export default Adminservice